import { UseQueryResult, useQuery } from 'react-query';
import { SalesPortalGymPaymentSettings } from 'types';
import { client } from 'utils/api-client';

export default function useSalesPortalGymPaymentSettings(
  gym?: string,
): UseQueryResult<{ data: SalesPortalGymPaymentSettings }> {
  return useQuery(
    ['salesPortalGymPaymentSettings', gym],
    () => client.get(`sales-portal/gyms/${gym}/payment-settings/`),
    {
      enabled: !!gym,
    },
  );
}
